import type { StorageUtils } from './types'

export function getStorageUtils(storage: Storage): StorageUtils {
  return {
    get: <T = string>(key: string, noParse = false): T | null => {
      const str = storage.getItem(key)

      if (!str) return null

      if (noParse) return str as T

      let item: T | null

      try {
        item = JSON.parse(str)
      } catch {
        item = null
      }

      return item
    },
    set: <T = string>(key: string, val: T, noStringify = false): boolean => {
      let item: string

      if (noStringify) {
        item = val as string
      } else {
        try {
          item = JSON.stringify(val)
        } catch {
          return false
        }
      }

      storage.setItem(key, item)

      return true
    },
    remove: (key: string): void => {
      storage.removeItem(key)
    },
    clear: (): void => {
      storage.clear()
    },
  }
}
